import { ISpaceTypeInfo } from '../../ts/models/resourceInfoParts';
import { AppState } from '../state/AppState';
import { SpaceInfo } from '../state/SpaceInfo';

export function selectSpaceInfo(state: AppState): SpaceInfo {
  return state.spaceInfo;
}

export function selectSpaceInfoItem(state: AppState): ISpaceTypeInfo {
    return state.spaceInfo.item;
}
